import useFormContext from "../../../hooks/useFormContext"
import React from "react";
import {translate} from "../../../i18n";
import {useDispatch, useSelector} from "react-redux";

const CompanyActivities = ({fields}) => {

    const { data, handleChange } = useFormContext()
    const dispatch = useDispatch();
    const language_code = useSelector(state => state.lang);
    const iso2 = useSelector((s) => s.country.country?.label) || 'togo';
    const countryCode = iso2.toLowerCase();

    const content = (
        <>
                <div className="flex-col">
                    <label htmlFor="isProducer">{translate('signup', language_code.lang).isProducer}</label>
                    <select
                        id="isProducer"
                        name="isProducer"
                        placeholder="choisir"
                        value={data.isProducer}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="true">{translate('signup', language_code.lang).yes}</option>
                        <option value="false">{translate('signup', language_code.lang).no}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="isSpeculator">{translate('signup', language_code.lang).isSpeculator}</label>
                    <select
                        id="isSpeculator"
                        name="isSpeculator"
                        placeholder="choisir"
                        value={data.isSpeculator}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="true">{translate('signup', language_code.lang).yes}</option>
                        <option value="false">{translate('signup', language_code.lang).no}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="isCooperative">{translate('signup', language_code.lang).isCooperative}</label>
                    <select
                        id="isCooperative"
                        name="isCooperative"
                        placeholder="choisir"
                        value={data.isCooperative}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="true">{translate('signup', language_code.lang).yes}</option>
                        <option value="false">{translate('signup', language_code.lang).no}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="isTrader">{translate('signup', language_code.lang).isTrader}</label>
                    <select
                        id="isTrader"
                        name="isTrader"
                        placeholder="choisir"
                        value={data.isTrader}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="true">{translate('signup', language_code.lang).yes}</option>
                        <option value="false">{translate('signup', language_code.lang).no}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="isTransformer">{translate('signup', language_code.lang).isTransformer}</label>
                    <select
                        id="isTransformer"
                        name="isTransformer"
                        placeholder="choisir"
                        value={data.isTransformer}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="true">{translate('signup', language_code.lang).yes}</option>
                        <option value="false">{translate('signup', language_code.lang).no}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="isImporter">{translate('signup', language_code.lang).isImporter}</label>
                    <select
                        id="isImporter"
                        name="isImporter"
                        placeholder="choisir"
                        value={data.isImporter}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="true">{translate('signup', language_code.lang).yes}</option>
                        <option value="false">{translate('signup', language_code.lang).no}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="isExporter">{translate('signup', language_code.lang).isExporter}</label>
                    <select
                        id="isExporter"
                        name="isExporter"
                        placeholder="choisir"
                        value={data.isExporter}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="true">{translate('signup', language_code.lang).yes}</option>
                        <option value="false">{translate('signup', language_code.lang).no}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="importExportType">{translate('signup', language_code.lang).importExportType}</label>
                    <select
                        id="importExportType"
                        name="importExportType"
                        placeholder="choisir"
                        value={data.importExportType}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="sa">{translate('company_informations', language_code.lang).import_export_type.agricultural_inputs}</option>
                        <option value="ong">{translate('company_informations', language_code.lang).import_export_type.agricultural_commodities}</option>
                        <option value="sas">{translate('company_informations', language_code.lang).import_export_type.agricultural_equipment_and_technology_trade}</option>
                        <option value="sarl">{translate('company_informations', language_code.lang).import_export_type.cross_border_agricultural_ervices}</option>

                    </select>
                </div>
            </>
    )

    return content
}
export default CompanyActivities